import * as authTypes from '../types/authTypes';

const initialState = {
  token: null,
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case authTypes.LOGIN_REQUEST:
    case authTypes.SIGNUP_REQUEST:
    case authTypes.ME_REQUEST:
    case authTypes.FORGOT_PASSWORD_REQUEST:
    case authTypes.RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case authTypes.LOGIN_SUCCESS:
    case authTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    case authTypes.ME_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    case authTypes.FORGOT_PASSWORD_SUCCESS:
    case authTypes.RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: null };
    case authTypes.LOGIN_FAILURE:
    case authTypes.SIGNUP_FAILURE:
    case authTypes.ME_FAILURE:
    case authTypes.FORGOT_PASSWORD_FAILURE:
    case authTypes.RESET_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case authTypes.LOGOUT:
      return { ...state, token: null, user: null, isAuthenticated: false, error: null };
    case authTypes.CLEAR_AUTH_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
}

export default authReducer;
